import React, {useEffect, useState} from "react";
import styled from "styled-components/macro";

import {
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent, CircularProgress,
  Typography as MuiTypography,
} from "@material-ui/core";

import {spacing} from "@material-ui/system";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SubscriptionInterface from '../../../integration/internal/SubscriptionInterface';
import Space from '../../../components/Space';
import {customAlert} from '../../../utils/AlertWrapper';
import {labelForTitle, valueForText, valueForInput} from '../../../views/dashboards/Devices/CardLayout';
import {Add as AddIcon} from "@material-ui/icons";
import {valueForLocationText} from "./CardLayout";
import CustomTextField from "../../../components/CustomTextField";
import {BUTTON_DISABLED, MAIN, WHITE} from "../../../constants/colors";

const Card = styled(MuiCard)(spacing);

const Typography = styled(MuiTypography)(spacing);

const CardContent = styled(MuiCardContent)`
  position: relative;

  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)}px;
  }
`;

const ClientInfoCard = ({data, callback}) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [name, setName] = useState(null);
  const [clientName, setClientName] = useState(null);
  const [location, setLocation] = useState(null);
  const [phone, setPhone] = useState(null);
  const [changed, setChanged] = useState(false);
  let installed = (!data.activated||data.activated==='N')? 'N/A':new Date(data.activated.replaceAll('-','/').split('.')[0].split('T')[0] + ' ' + data.activated.replaceAll('-','/').split('.')[0].split('T')[1] + ' UTC');
  let deactivated = (!data.deactivated||data.deactivated==='N')? 'N/A':new Date(data.deactivated.replaceAll('-','/').split('.')[0].split('T')[0] + ' ' + data.deactivated.replaceAll('-','/').split('.')[0].split('T')[1] + ' UTC');

  useEffect(() => {
    // console.log('client data=='+JSON.stringify(data));
    if (name == null || name == undefined) setName(data.device_name || null);
    if (clientName == null || clientName == undefined) setClientName(data.client_name || null);
    if (location == null || location == undefined) setLocation(formatLocation(data.device_location));
    if (phone == null || phone == undefined) setPhone(data.phone || null);
    checkChange();
  });

  const formatLocation = (address) => {
    if (!address) return null;
    const {street, city, state, zipcode} = address;
    let formattedAddress = '';
    if (street!=null && street!='') {
      formattedAddress = street;
    }
    if (city!=null && city!='') {
      if(formattedAddress!='') formattedAddress += ', ' + city
      else formattedAddress = city
    }
    if (state!=null && state!='') {
      if(formattedAddress!='') formattedAddress += ', ' + state
      else formattedAddress = state
    }
    if (zipcode!=null && zipcode!='') {
      if(formattedAddress!='') formattedAddress += ', ' + zipcode
      else formattedAddress = zipcode
    }
    return formattedAddress;
  };

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const onClientNameChange = (event) => {
    setClientName(event.target.value);
  };

  const onLocationChange = (event) => {
    // setLocation(event.target.value);
  };

  const onPhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const applyChange = async () => {
    setShowSpinner(true);
    let result = await SubscriptionInterface.changeClientInformation(localStorage.getItem('0xaccountId'), data.serial_number, clientName, name, location, phone);
    if (result) {
      setChanged(false);
      callback(data.serial_number);
    } else {
      customAlert('Fail to apply changes');
    }
    setShowSpinner(false);
  };

  const checkChange = () => {
    // console.log("name != data.device_name = " + name != data.device_name);
    // console.log("location != formatLocation(data.device_location) = " + location != formatLocation(data.device_location));
    // console.log("clientName != data.client_name = " + clientName != data.client_name);
    // console.log("phone != data.phone = " + phone != data.phone);
    if (name != (data.device_name || null) || clientName != (data.client_name || null) || phone != (data.phone || null) ) {
      setChanged(true);
    } else setChanged(false);
  };

  return (
    !data.serial_number ? (
      <Card mb={3} className='loading-card'>
        <CircularProgress/>
      </Card>
    ) : (
    <Card mb={3} className='common-card'>
      <CardContent>
        <Box display='flex' flexDirection='row' justifyContent={'flex-start'} alignItems={'center'}>
          <Box style={{width: '100%'}}>
            <Typography variant={'subtitle1'} mb={3}>
              <Box fontWeight="fontWeightBold">Client Information</Box>
            </Typography>
          </Box>
          <Box style={{width:'60px'}}></Box>
          <Box display='flex' flexDirection='row' justifyContent={'flex-start'} alignItems={'center'}>
            {changed ?
              <Button style={{background: changed ? '#3DB5E6' : '#E0E0E0', color: '#FFFFFF'}} onClick={applyChange}>Save</Button> :
              <Button style={{background: '#E0E0E0', color: '#FFFFFF'}} disabled>Save</Button>}
            {
              showSpinner ?
                <div className='save-changes-spinner'>
                  <CircularProgress size={20}/>
                </div> : <></>
            }
          </Box>
        </Box>
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Client Email Address</Typography>
        <CustomTextField
          style={valueForText}
          name="clidentEmailAddress"
          placeholder={''}
          value={data.client&&data.client!=''? data.client: 'N/A'}
          fullWidth
          disabled
          InputProps={true ? { disableUnderline: true } : {}}
          my={3}
        />
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Client Name</Typography>
        <CustomTextField
          style={valueForText}
          name="clientName"
          placeholder={''}
          value={clientName}
          fullWidth
          onChange={onClientNameChange}
          my={3}
        />
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Activated Date</Typography>
        <CustomTextField
          style={valueForText}
          name="activatedDate"
          placeholder={''}
          value={installed==='N/A'? installed: (installed.getMonth() + 1) + '/' + installed.getDate() + '/' + installed.getFullYear()}
          fullWidth
          disabled
          InputProps={true ? { disableUnderline: true } : {}}
          my={3}
        />
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Deactivated Date</Typography>
        <CustomTextField
          style={valueForText}
          name="deactivatedDate"
          placeholder={''}
          value={deactivated==='N/A'? '': (deactivated.getMonth() + 1) + '/' + deactivated.getDate() + '/' + deactivated.getFullYear()}
          fullWidth
          disabled
          InputProps={true ? { disableUnderline: true } : {}}
          my={3}
        />
        {/*<Box display='flex' flexDirection='row' justifyContent={'flex-start'} alignItems={'center'}>*/}
        {/*  <Box style={{width: '100%'}}>*/}
        {/*    <Typography style={labelForTitle}>Activated Date</Typography>*/}
        {/*    <CustomTextField*/}
        {/*      style={valueForText}*/}
        {/*      name="activatedDate"*/}
        {/*      placeholder={''}*/}
        {/*      value={installed==='N/A'? installed: (installed.getMonth() + 1) + '/' + installed.getDate() + '/' + installed.getFullYear()}*/}
        {/*      fullWidth*/}
        {/*      disabled*/}
        {/*      InputProps={true ? { disableUnderline: true } : {}}*/}
        {/*      my={3}*/}
        {/*    />*/}
        {/*  </Box>*/}
        {/*  <Box style={{width:'60px'}}></Box>*/}
        {/*  <Box style={{width: '100%'}}>*/}
        {/*    <Typography style={labelForTitle}>Deactivated Date</Typography>*/}
        {/*    <CustomTextField*/}
        {/*      style={valueForText}*/}
        {/*      name="deactivatedDate"*/}
        {/*      placeholder={''}*/}
        {/*      value={deactivated==='N/A'? deactivated: (deactivated.getMonth() + 1) + '/' + deactivated.getDate() + '/' + deactivated.getFullYear()}*/}
        {/*      fullWidth*/}
        {/*      disabled*/}
        {/*      InputProps={true ? { disableUnderline: true } : {}}*/}
        {/*      my={3}*/}
        {/*    />*/}
        {/*  </Box>*/}
        {/*</Box>*/}
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Device Name</Typography>
        <CustomTextField
          style={valueForText}
          name="deviceName"
          value={name}
          fullWidth
          onChange={onNameChange}
          my={3}
        />
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Device Location</Typography>
        <CustomTextField
          style={valueForText}
          name="deviceLocation"
          placeholder={''}
          value={formatLocation(data.device_location)}
          fullWidth
          disabled
          InputProps={true ? { disableUnderline: true } : {}}
          my={3}
        />
        <Space height={'20px'}/>
        <Typography style={labelForTitle}>Client Phone Number</Typography>
        <CustomTextField
          style={valueForText}
          name="phone"
          fullWidth
          value={phone}
          onChange={onPhoneChange}
          my={3}
        />
      </CardContent>
    </Card>
    )
  );
};

export default ClientInfoCard;
